import { useEffect, useState } from 'react'

const DelayedFallback = ({ delay = 300, children }) => {
	const [show, setShow] = useState(false)

	useEffect(() => {
		const id = setTimeout(() => setShow(true), delay)
		return () => clearTimeout(id)
	}, [delay])

	return show ? children : null
}

export default DelayedFallback
